import { nanoid } from "nanoid";
import * as ENUMS from "./enums";
import STORE_ENUMS from "store/enums";

export const OPEN_COMPOSE = "composeActions::OpenCompose";
export const CLOSE_COMPOSE = "composeActions::CloseCompose";
export const SET_COMPOSE_STATUS = "composeActions::SetComposeStatus";

export const SET_DRAFT_STATUS = "composeActions::setDraftSaving";
export const SET_HEADER_TITLE = "composeActions::setTitle";

export const FOCUS_COMPOSE = "composeActions::FocusCompose";
export const BLUR_COMPOSE = "composeActions::BlurCompose";
export const SET_COMPOSE_POSITION = "composeActions::SetComposePosition";
export const DISMISS_COMPOSE_LIMIT = "composeActions::DismissComposeLimit";

export const openCompose = ({
  id = null,
  mode = STORE_ENUMS.COMPOSE.MODE.DEFAULT,
  fields = {},
  attachment_ids = []
}) => {
  return {
    type: OPEN_COMPOSE,
    payload: {
      id: nanoid(),
      fetchId: id,
      mode,
      attachment_ids,
      fields,
      // the reducer lays the windows out for the screen they open on
      viewportWidth: document.documentElement.clientWidth
    }
  };
};

export const closeCompose = payload => {
  return {
    type: CLOSE_COMPOSE,
    payload
  };
};

export const externalTabCompose = id => {
  return {
    type: SET_COMPOSE_STATUS,
    payload: {
      id,
      status: ENUMS.EXTERNALTAB_COMPOSE
    }
  };
};

export const hideCompose = id => {
  return {
    type: SET_COMPOSE_STATUS,
    payload: {
      id,
      status: ENUMS.HIDE_COMPOSE
    }
  };
};

export const expandCompose = id => {
  return {
    type: SET_COMPOSE_STATUS,
    payload: {
      id,
      status: ENUMS.EXPANDED_COMPOSE
    }
  };
};

export const maximizeCompose = id => {
  return {
    type: SET_COMPOSE_STATUS,
    payload: {
      id,
      status: ENUMS.MAXIMIZE_COMPOSE
    }
  };
};

export const minimizeCompose = id => {
  return {
    type: SET_COMPOSE_STATUS,
    payload: {
      id,
      status: ENUMS.MINIMIZE_COMPOSE
    }
  };
};

export const collapseCompose = id => {
  return {
    type: SET_COMPOSE_STATUS,
    payload: {
      id,
      status: ENUMS.COLLAPSE_COMPOSE
    }
  };
};

export const draftSaving = id => {
  return {
    type: SET_DRAFT_STATUS,
    payload: {
      id,
      status: ENUMS.DRAFT_SAVING
    }
  };
};

export const draftSaved = id => {
  return {
    type: SET_DRAFT_STATUS,
    payload: {
      id,
      status: ENUMS.DRAFT_SAVED
    }
  };
};

export const draftFailed = id => {
  return {
    type: SET_DRAFT_STATUS,
    payload: {
      id,
      status: ENUMS.DRAFT_FAILED
    }
  };
};

export const setHeaderTitle = ({ id, title }) => {
  return {
    type: SET_HEADER_TITLE,
    payload: {
      id,
      title
    }
  };
};

export const focusCompose = id => {
  return {
    type: FOCUS_COMPOSE,
    payload: id
  };
};

export const blurCompose = () => {
  return {
    type: BLUR_COMPOSE
  };
};

export const setComposePosition = ({ id, x }) => {
  return {
    type: SET_COMPOSE_POSITION,
    payload: {
      id,
      x
    }
  };
};

export const dismissComposeLimit = () => {
  return {
    type: DISMISS_COMPOSE_LIMIT
  };
};
